import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from 'environments/environment';

@Injectable()
export class CanActivateLanding implements CanActivate {
  constructor(private router: Router) {}

  public canActivate(): boolean {
    if (!environment.landingEnabled) {
      this.router.navigate(['/stories']);
      return false;
    }

    return true;
  }
}
